import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import BadgeIcon from '@mui/icons-material/Badge';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';

import { Tabs, TabsStrategy } from '../../components/Tabs';
import { Breadcrumbs } from '../../components/Breadcrumbs';
import { SpeedDial } from '../../components/SpeedDial';
import {
  PATH_USERS_INTERNAL,
  PATH_USERS_EXTERNAL,
  PATH_USERS_DISABLED,
  PATH_USERS_DEFAULT,
  PATH_USERS_NEW_INTERNAL,
  PATH_USERS_NEW_EXTERNAL,
} from '../../app/constants/paths.constant';
import { Page } from '../../contexts/NavigationContext/enums/page.enum';
import { useNavigationContext } from '../../contexts/NavigationContext/hooks/useNavigationContext.hook';
import { buildDocumentTitle } from '../../utils/document-title.util';
import { PageTitle } from '../../components/PageTitle';

import { InternalUsersTabPanel } from './Internal';
import { ExternalUsersTabPanel } from './External';
import { DisabledUsersTabPanel } from './Disabled';

export const UsersPage = () => {
  const { setPage } = useNavigationContext();

  useEffect(() => {
    setPage(Page.Users);
  }, [setPage]);

  return (
    <>
      <Helmet>
        <title>{buildDocumentTitle('Liste des Utilisateurs')}</title>
      </Helmet>
      <Breadcrumbs
        paths={[
          {
            to: PATH_USERS_DEFAULT,
            label: 'utilisateurs',
            key: 'users',
          },
        ]}
      />
      <PageTitle title="Liste des Utilisateurs" />
      <Tabs
        id="users-tabs"
        strategy={TabsStrategy.RouterConnected}
        tabs={[
          {
            key: 'internalUsers',
            label: 'Internes',
            panel: <InternalUsersTabPanel />,
            to: PATH_USERS_INTERNAL,
          },
          {
            key: 'externalUsers',
            label: 'Externes',
            panel: <ExternalUsersTabPanel />,
            to: PATH_USERS_EXTERNAL,
          },
          {
            key: 'disabledUsers',
            label: 'Désactivés',
            panel: <DisabledUsersTabPanel />,
            to: PATH_USERS_DISABLED,
          },
        ]}
        title="Onglets de l'écran de Liste des Utilisateurs"
      />
      <SpeedDial
        actions={[
          {
            id: 'createInternalUser',
            icon: <BadgeIcon />,
            name: 'Utilisateur Interne',
            to: PATH_USERS_NEW_INTERNAL,
          },
          {
            id: 'createExternalUser',
            icon: <PersonAddAltIcon />,
            name: 'Utilisateur Externe',
            to: PATH_USERS_NEW_EXTERNAL,
          },
        ]}
        title="Actions possibles sur les Utilisateurs"
      />
    </>
  );
};
